import { useEffect, useState } from "react";
import { BasePageContainer } from "../../../../components/common";
import CustomLoader from "../../../../components/common/CustomLoader";
import EmotionalLevelLineChart from "./charts/EmotionalLevelLine";
import images from "../../../../helper/images";
import { EL_RESONANCE_DATA, NEUROTRANSMITTER_DATA } from "../../../../service/mock-data/impart";

const ImpartDetail = () => {

  const [loading, setLoading] = useState(false);

  useEffect(() => {
  }, []);

  const generateNeuroTransmitterConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["dopamine", "cortisol", "serotonin"],
      data: NEUROTRANSMITTER_DATA
    }
  }

  const generateELResonanceConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["vision", "hearing", "smell", "taste", "touch"],
      data: EL_RESONANCE_DATA,
    }
  }

  const generateVisionConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["vision"],
      data: EL_RESONANCE_DATA.map(i => ({ vision: i.vision })),
      height: 250,
      backgroundColor: '#0088FE'
    }
  }
  const generateHearingConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["hearing"],
      data: EL_RESONANCE_DATA.map(i => ({ hearing: i.hearing })),
      height: 200,
      backgroundColor: '#00C49F'
    }
  }
  const generateSmellConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["smell"],
      data: EL_RESONANCE_DATA.map(i => ({ smell: i.smell })),
      height: 175,
      backgroundColor: '#FFBB28'
    }
  }
  const generateTasteConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["taste"],
      data: EL_RESONANCE_DATA.map(i => ({ taste: i.taste })),
      height: 150,
      backgroundColor: '#FF8042'
    }
  }
  const generateTouchConfig = () => {
    return {
      title: '',
      labels: ["Time (Minutes)", ""],
      datakeys: ["touch"],
      data: EL_RESONANCE_DATA.map(i => ({ touch: i.touch })),
      height: 150,
      backgroundColor: 'pink'
    }
  }

  const renderImpartDetail = () => {
    const neuroData = generateNeuroTransmitterConfig();
    const elResonance = generateELResonanceConfig();
    const visionConfig = generateVisionConfig();
    const hearingConfig = generateHearingConfig();
    const smellConfig = generateSmellConfig();
    const tasteConfig = generateTasteConfig();
    const touchConfig = generateTouchConfig();

    return <section className="mt-4">
      <div className="container">
        <h2 className="text-blue mb-4 h5 font-weight-bold"> Content Impact Analyzer</h2>
        <LineChartCombo title={'Emotional Resonance Graph - Neurotransmitter'} config={neuroData} />

        <div className="mt-4">
          <LineChartCombo title={'Emotional Resonance Graph - EL’s'} config={elResonance} />
        </div>

        <div className="mt-4">
          <div
            className="d-flex align-items-center justify-content-between">
            <div className="mb-2 text-blue">Emotional Resonance Graph - Senses</div>
            <div
              className="d-flex align-items-center white-space-nowrap">
              <div className="pr-2"> Time Gap :</div>
              <select className="form-control1 time-gap border-0"
                id="mySelect">
                <option value>10 Min</option>
                <option value="1">Option 1</option>
                <option value="2">Option 2</option>
                <option value="3">Option 3</option>
              </select>
            </div>
          </div>
          <div className="chart-bg border p-3">
            <div className="d-flex align-items-center gap-15 mb-4">
              <div className="d-flex align-items-center gap-10">
                <div className="text-blue">Vision</div>
                <img src={images.vision} alt="vision" />
              </div>
              {renderLineChart(visionConfig)}
            </div>
            <div className="d-flex align-items-center gap-15 mb-4">
              <div className="d-flex align-items-center gap-10">
                <div className="text-blue">Hearing</div>
                <img src={images.hearing} alt="hearing" />
              </div>
              {renderLineChart(hearingConfig)}
            </div>
            <div className="d-flex align-items-center gap-15 mb-4">
              <div className="d-flex align-items-center gap-10">
                <div className="text-blue">Smell</div>
                <img src={images.smell} alt="smell" />
              </div>
              {renderLineChart(smellConfig)}
            </div>
            <div className="d-flex align-items-center gap-15 mb-4">
              <div className="d-flex align-items-center gap-10">
                <div className="text-blue">Touch</div>
                <img src={images.touch} alt="touch" />
              </div>
              {renderLineChart(tasteConfig)}
            </div>
            <div className="d-flex align-items-center gap-15 mb-4">
              <div className="d-flex align-items-center gap-10">
                <div className="text-blue">Taste</div>
                <img src={images.taste} alt="taste" />
              </div>
              {renderLineChart(touchConfig)}
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  const renderLineChart = (config) => {
    const { height } = config
    return <div style={{ width: '100%', height }}><EmotionalLevelLineChart config={config} /></div>
  }

  return (
    <BasePageContainer>
      {loading && <CustomLoader full />}
      <div className="pb-5">
        {renderImpartDetail()}
      </div>
    </BasePageContainer>
  );
};

export default ImpartDetail;

const LineChartCombo = ({ title, config }) => {
  const render = () => {
    return (
      <div className="">
        <div
          className="d-flex align-items-center justify-content-between">
          <div className="mb-2 text-blue">{title || ''}</div>
          <div
            className="d-flex align-items-center white-space-nowrap">
            <div className="pr-2"> Time Gap :</div>
            <select className="form-control1 time-gap border-0"
              id="mySelect">
              <option value>10 Min</option>
              <option value="1">Option 1</option>
              <option value="2">Option 2</option>
              <option value="3">Option 3</option>
            </select>
          </div>
        </div>
        <div className="chart-bg border p-3" style={{ height: config.height || 400 }}>
          <EmotionalLevelLineChart config={config} />
        </div>
      </div>
    )
  }

  return render()
}
